export default __webpack_public_path__ + "static/media/ephemeralart_hd.54ee8c68.webp";